import { IBaseJsonRpcProvider } from "./provider";
export class IMultiServiceProvider extends IBaseJsonRpcProvider {
    constructor(config) {
        super();
        this.config = config;
    }
}
//# sourceMappingURL=multi.js.map